'use client';
import React from 'react';

import styled from 'styled-components';

const Wrapper = styled.div<{ isVisible: boolean }>`
  /* flex-grow: 1; */
  flex-shrink: 0;

  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
`;

interface HideBoundaryProps {
  children: React.ReactNode;
  minWidth: number;
  parentRef: React.RefObject<HTMLDivElement>;
}

export default function HideBoundary({ children, minWidth, parentRef }: HideBoundaryProps) {
  const [isVisible, setIsVisible] = React.useState(true);
  // const parentRef = useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const checkParentWidth = () => {
      if (parentRef.current) {
        setIsVisible(parentRef.current.offsetWidth >= minWidth);
      }
    };

    // Initial check
    checkParentWidth();

    // ResizeObserver to track parent width changes
    const resizeObserver = new ResizeObserver(checkParentWidth);
    if (parentRef.current) {
      resizeObserver.observe(parentRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [minWidth]);

  return <Wrapper isVisible={isVisible}>{children}</Wrapper>;
}
